/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { SortDirection } from 'cio/utils/sort';
import { LeaderBoardCardItem, LeaderboardCardTab } from 'cio/utils/components/leaderboard-card';
import { ActionType } from 'cio/models/action';
import { deliveryStatesAndActionsPerType } from 'cio/utils/action-info';
import { findDenominator, MeasureType } from 'cio/utils/metrics/measure';
import { Measure } from 'cio/utils/metrics/common';
import { CampaignType } from 'cio/models/campaign';

interface LeaderboardCardItemArgs {
  item: LeaderBoardCardItem;
  index: number;
  activeTabItem: LeaderboardCardTab;
  sortDirection: SortDirection;
  trackNavigate: (destination: string, itemId?: string) => unknown;
  channels: string[];
  showValueTooltip: boolean;
  showItemMetricTooltip: boolean;
}

export default class LeaderboardCardItem extends Component<LeaderboardCardItemArgs> {
  get containerClass() {
    let classes = ['leaderboard-card-item-panel'];

    if (this.args.index === 0) {
      if (this.args.sortDirection === SortDirection.Descending) {
        classes.push('leaderboard-card-item-panel--success');
      } else {
        classes.push('leaderboard-card-item-panel--warning');
      }
    }

    return classes.join(' ');
  }

  @action
  trackNavigate() {
    let destination = 'campaign';

    if (this.args.item.type === 'newsletter') {
      destination = 'newsletter';
    } else if (this.args.item.type === CampaignType.APITriggered) {
      destination = 'broadcast';
    } else if (this.args.item.type === 'action') {
      destination = 'vwb';
    }

    return this.args.trackNavigate(destination, this.args.item.id);
  }

  get actionTypesForTab() {
    let actionTypes = this.args.channels.map((c) => `${c}_action` as ActionType);

    if (this.args.item.type === 'newsletter') {
      actionTypes = [`${this.args.item.channel}_action` as ActionType];
    }

    let deliveryStates = deliveryStatesAndActionsPerType(this.args.item?.conversion);
    return Object.keys(deliveryStates).reduce<ActionType[]>((acc, key: ActionType) => {
      let measures = deliveryStates[key];

      if (measures.includes(this.args.activeTabItem.value) && actionTypes.includes(key)) {
        acc = [...acc, key];
      }

      return acc;
    }, []);
  }

  get denominatorTotal() {
    if (!this.args.activeTabItem.isRate) {
      return 0;
    }

    return this.actionTypesForTab.reduce<number>((acc, type) => {
      let denominator = findDenominator(this.args.activeTabItem.value as Measure, MeasureType.DeliveryMetrics, type);
      if (denominator == null) {
        return acc;
      }

      let channel = type.replace('_action', '');

      return acc + ((this.args.item.data.per_channel_metrics?.[channel]?.[`total_${denominator}`] as number) ?? 0);
    }, 0);
  }

  get optionalConversions() {
    return {
      webhook_action: this.args.item?.conversion,
    };
  }
}
